export enum PromotionRequestActionEnum {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  STOP = 'STOP',
  CONTINUE = 'CONTINUE',
}
